<template>
  <div class="home">
    <!-- 头部区域 -->
    <div class="home-header">
      <div style="flex: 1; font-size: 18px;">
        <span style="letter-spacing: 2px;">科技奖申报系统</span>
      </div>
      <!-- <el-button type="info" class="pull-right" @click="out">退出</el-button> -->
      <div style="display: flex; align-items: center;">
        <div style="margin-right: 40px;" @click="handleN">
          <el-badge :value="$store.state.count" class="item" :max="99" :hidden="$store.state.count == 0">
            <i class="el-icon-message-solid cursor" style="font-size: 20px;"></i>
          </el-badge>
        </div>
        <el-dropdown>
          <span class="cursor" style="line-height: 60px;">
            <span style="font-size: 20px; color: #fff; margin-top: 10px;" class="iconfont icon-guanliyuan-2"></span>
            <span style="padding-left: 6px; color: #fff; vertical-align: top">{{info.nickName}}</span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="handleJump">
              <span style="font-size: 16px; margin-right:4px;" class="iconfont icon-yonghu-3"></span>
              个人中心
            </el-dropdown-item>
            <el-dropdown-item @click.native="out">
              <span style="font-size: 16px; margin-right:4px;" class="iconfont icon-tuichu1"></span>
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 页面主体区域 -->
    <div class="home-container">
      <!-- 侧边栏 -->
      <div class="home-aside">
        <!-- <div class="toggle-button" @click="toggleCollapse">|||</div> -->
        <!-- 侧边栏菜单区域 -->
        <el-menu
        background-color="#1558A3"
        text-color="#fff"
        active-text-color="#409EFF"
        unique-opened
        :collapse="isCollapse"
        :collapse-transition="false"
        router
        :default-active="$route.meta.activeMenu">
        <menu-sun :menu="menulist" />
        </el-menu>
      </div>
      <div class="home-main" id="home-main" ref="scrollbarRef">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <div style="height: 20px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuSun from '@/components/menuList/MenuList.vue'
import { getUserInfo, projectUpPsd } from '@/api/admin'
import { LoginAdminLogout } from '@/api/system'
export default {
  name: 'Home',
  components: { MenuSun },
  data () {
    return {
      menulist: [
        { name: '项目奖申报', href: '/project/batch', icon: 'iconfont icon-xiangmujiangshenbao' },
        { name: '个人奖申报', href: '/personal/batch', icon: 'iconfont icon-gerenjiangshenbao' },
        { name: '通知消息', href: '/notification', icon: 'iconfont icon-quanzhongpeizhi' },
        { name: '个人中心', href: '/userCenter', icon: 'iconfont icon-role' }
      ],
      info: {},
      isCollapse: false,
      activePath: ''
    }
  },
  watch: {
    '$route.path' (newValue, oldValue) {
      if (newValue == '/project/add1' || newValue == '/project/details' || newValue == '/project/award' || newValue == '/personal/award' || newValue == '/personal/add1' || newValue == '/personal/details') {
        this.$refs.scrollbarRef.scrollTo({ top: 0 })
      }
      // const index = newValue.split('/').length - 1
      // if (index == 1) {
      //   this.activePath = newValue
      // } else {
      //   this.activePath = newValue.substring(0, this.findStrIndex(newValue, '/', 2))
      // }
    }
  },
  created() {
    this.$store.dispatch('updateCount')
    getUserInfo().then(res => {
      if (res.code === '000') {
        this.info = res.result
        // this.$store.commit('setPhone', res.result.loginName)
        // this.$store.commit('setId', res.result.id)

        this.$store.commit('setUserInfo', {
          id: res.result.id,
          phone: res.result.loginName,
          nickName: res.result.nickName,
          unitName: res.result.unitName,
          toEmail: res.result.toEmail
        })
        if (res.result.days >= 90) {
          projectUpPsd()
          this.$alert('您已超过90天未修改登录密码。为了您的账号安全，请前往修改密码', '提示', {
            confirmButtonText: '确定',
            callback: action => {}
          })
          // this.$confirm('您已超过20天未修改登录密码。为了您的账号安全，请前往修改密码。', '提示', {
          //   confirmButtonText: '确 定',
          //   cancelButtonText: '取 消',
          //   type: ''
          // }).then(() => {
          //   projectUpPsd()
          // })
        }
      }
    })
    // const index = this.$route.path.split('/').length - 1
    // if (index == 1) {
    //   this.activePath = this.$route.path
    // } else {
    //   this.activePath = this.$route.path.substring(0, this.findStrIndex(this.$route.path, '/', 2))
    // }
    this.getMenuList()
  },
  methods: {
    handleN() {
      this.$router.push({ path: '/notification' })
    },
    // 出现次数
    findStrIndex (str, cha, num) {
      var x = str.indexOf(cha)
      for (let i = 0; i < num - 1; i++) {
        x = str.indexOf(cha, x + 1)
      }
      return x
    },
    // 获取左侧菜单
    getMenuList() {
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    out() {
      this.$confirm('是否确定退出?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // window.sessionStorage.clear()
        // this.$message.success('退出成功')
        // this.$router.push({ path: '/login' })
        LoginAdminLogout().then(res => {
          window.sessionStorage.clear()
          this.$message.success('退出成功')
          this.$router.push({ path: '/login' })
        })
      }).catch(() => {})
    },
    handleJump () {
      this.$router.push({ path: '/userCenter' })
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .home-header {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    height: 60px;
    // line-height: 60px;
    background-color: #373d41;
    background: #2784EC;
    color: #fff;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .home-container {
    position: fixed;
    top: 60px;
    left: 0;
    bottom: 0px;
    width: 100%;
    display: flex;
    .home-aside {
      position: relative;
      top: 0;
      left: 0;
      height: 100%;
      background: #333744;
      background: #1558A3;
      overflow-y: auto;
      width: 200px;
    }
    .home-main {
      flex: 1;
      height: 100%;
      padding: 20px;
      padding-bottom: 0;
      box-sizing: border-box;
      overflow-y: auto;
    }
  }
}
.el-menu {
  border: none;
}
.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}

</style>
<style>
.home-header .el-badge__content {
  height: 14px;
  line-height: 14px;
  padding: 0 4px;
  cursor: pointer;
}
</style>
